export default "__VITE_ASSET__d2cd2d4c__"